(function(){
'use strict';

scCampaignProgress.$inject = ["$filter", "scProgressDataFactory", "scUserAgent"];
function scCampaignProgress($filter, scProgressDataFactory, scUserAgent) {
  return {
    scope: {
      entity: '=',
      active: '=?',
      hasStatsHidden: '=?',
      hasRaisedHidden: '=?',
      endsAt: '=?',
      supporters: '=?',
      enableSupporters: '=?',
      btnColor: '=?',
      barColor: '=?',
      backgroundColor: '=',
      campaignType: '=',
      styleClass: '@?',
      isEndedAtHidden: '=?',
      isPercentHidden: '=?',
      enableProgressBar: '=?',
      entityType: '@?' // Optional explicit entity type ('team', 'page', 'parentTeam', etc.)
    },
    template: '<div ng-include="getTemplateUrl()"></div>',
    link: function link(scope) {
      update(scope.entity);

      if (scope.active && scope.active.registerObserverCallback) {
        scope.active.registerObserverCallback(update);
      }

      function update(current) {
        var progressPromise = void 0;

        if (current && current.classy_mode_enabled != null) {
          // random entity property to check whether campaign or not
          progressPromise = scProgressDataFactory.getCampaignProgress(current);
        } else {
          // Pass explicit entity type if provided
          progressPromise = scProgressDataFactory.getEntityProgress(current, scope.entityType);
        }

        // Handle both promise and direct return for backward compatibility
        Promise.resolve(progressPromise).then(function (progressData) {
          scope.currency = progressData.currency;
          var isMobile = scUserAgent.isMobile();

          if (isMobile && scope.currency === 'USD') {
            scope.rawGoalAmount = '$' + $filter('friendlyShortNumber')(progressData.goal);
          } else {
            scope.rawGoalAmount = $filter('scFormatCurrency')(progressData.goal, scope.currency, 0);
          }

          scope.total_raised = progressData.totalRaised;
          scope.percentRaised = $filter('scPercent')(progressData.percentToGoal, 0, '');

          // Trigger digest cycle since we're using native Promise
          scope.$apply();
        }).catch(function (error) {
          console.error('Error updating progress data:', error); // eslint-disable-line no-console
          // Set default values on error
          scope.currency = 'USD';
          scope.rawGoalAmount = '$0';
          scope.total_raised = 0;
          scope.percentRaised = '0%';
          scope.$apply();
        });
      }

      scope.getTemplateUrl = function () {
        var template = void 0;

        switch (scope.campaignType) {
          case 'p2p':
            template = 'global/directives/scCampaignProgress/p2p/template';
            break;

          case 'crowdfunding':
            template = 'global/directives/scCampaignProgress/crowdfunding/template';
            break;

          default:
            template = 'global/directives/scCampaignProgress/template';
            break;
        }

        return template;
      };
    }
  };
}

angular.module('classy').directive('scCampaignProgress', scCampaignProgress);
})();